var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((50),function(i){return _c('div',{key:`snow-${i}`,staticClass:"snow"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }